import * as React from "react";
import { IconProps } from "../types";

const FaceSleepingOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="9.5" cy="12" r="1" fill={color} stroke="none" />
          <path d="M6.985,8c-.126,.119-.554,.496-1.228,.559-.636,.06-1.105-.195-1.258-.286" />
          <path d="M10.015,8c.126,.119,.554,.496,1.228,.559,.636,.06,1.105-.195,1.258-.286" />
          <polyline points="13.75 .75 17.25 .75 13.75 4.75 17.25 4.75" />
          <path d="M12.173,2.757c-1.078-.636-2.331-1.007-3.673-1.007C4.496,1.75,1.25,4.996,1.25,9s3.246,7.25,7.25,7.25,7.25-3.246,7.25-7.25c0-.604-.082-1.188-.222-1.75" />
        </g>
      </svg>
    );
  },
);

export default FaceSleepingOutlineIcon;
